// src/components/SeoHelmet.js
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import SEO_DATA from "../../Seo";

const SeoHelmet = () => {
  const location = useLocation();
  const { pathname } = location;

  const seo = SEO_DATA[pathname] || {
    title: "Peregrinee | #1 Global IT & Digital Transformation Agency",
    description: "Leading IT & Digital Transformation Services",
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
    </Helmet>
  );
};

export default SeoHelmet;
